// extracted by mini-css-extract-plugin
export default {"emailTab":"ChannelShareModal_emailTab__UP9bo","btn":"ChannelShareModal_btn__iIYUp"};